var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auth-wrapper email-unverified" }, [
    !_vm.isMobile
      ? _c("div", { staticClass: "auth-wrapper auth-wrapper-left" })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "auth-wrapper-rigth" }, [
      _c(
        "div",
        { staticClass: "auth-wrapper__content" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$t("auth.emailUnverified.pleaseConfirmYourEmailAt")
                ) +
                "\n            "
            ),
            _c("strong", [_vm._v(_vm._s(_vm.email))]),
            _vm._v(
              "  \n            " +
                _vm._s(_vm.$t("auth.emailUnverified.toContinue")) +
                "\n          "
            )
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "primary", disabled: _vm.sent },
              on: { click: _vm.sendEmailVerification }
            },
            [
              _vm._v(
                _vm._s(_vm.$t("auth.emailUnverified.resendEmailConfirmation"))
              )
            ]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "text-center" }, [
            _c(
              "a",
              { attrs: { href: "javascript:" }, on: { click: _vm.signout } },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("auth.emailUnverified.signInWithAnotherAccount")
                  )
                )
              ]
            )
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "auth-wrapper__logo logo" }, [
      _c("figure", { staticClass: "figure-logo" }, [
        _c("img", {
          attrs: { src: "/static/logos/logo_dv7.png", alt: "40%", width: "80%" }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74017252", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74017252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/auth/email-unverified/email-unverified.vue
// module id = null
// module chunks = 